import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/row.css'
import 'element-ui/lib/theme-chalk/col.css'
import VueCompositionAPI from '@vue/composition-api'
import axios from 'axios'
import permissionDirective from './directives/permission'
import encryptionUtils from './utils/encryption'
import { getPublicKey } from './api/encryption'
import './assets/styles/global.css'

Vue.use(VueCompositionAPI)

// 配置axios
axios.defaults.baseURL = '/api'
axios.defaults.headers.common['Content-Type'] = 'application/json'

// 应用初始化时获取RSA公钥
async function initEncryption() {
  try {
    const response = await getPublicKey()
    if (response.code === 200 && response.data) {
      encryptionUtils.setPublicKey(response.data.publicKey)
      console.log('公钥获取成功')
    } else {
      console.error('获取公钥失败:', response.message)
    }
  } catch (error) {
    console.error('获取公钥失败:', error)
  }
}

// 初始化加密
initEncryption()

// 请求拦截器，添加权限标识、token和加密
axios.interceptors.request.use(async config => {
  // 添加token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  // 添加权限标识
  const userStr = localStorage.getItem('user')
  if (userStr) {
    const user = JSON.parse(userStr)
    if (user.permissions && user.permissions.length > 0) {
      config.headers['X-Permissions'] = user.permissions.join(',')
    }
  }
  
  // 加密请求数据
  if (config.method === 'post' && config.data) {
    const skipEncryptUrls = ['/auth/getPublicKey', '/auth/captcha', '/auth/login']
    const shouldSkip = skipEncryptUrls.some(url => config.url && config.url.includes(url))
    if (!shouldSkip) {
      try {
        // console.log('请求地址:', config.url, '未加密入参:', JSON.parse(JSON.stringify(config.data)))
        const encryptedData = encryptionUtils.encryptRequest(config.data)
        // 只有加密成功（返回对象包含encryptedData字段）时才设置加密头
        if (encryptedData && encryptedData.encryptedData) {
          config.data = encryptedData
          config.headers['X-Encrypted'] = 'true'
        }
      } catch (error) {
        console.error('加密请求数据失败:', error)
      }
    }
  }
  
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器，处理错误和解密
axios.interceptors.response.use(response => {
  // 解密响应数据
  if (response.headers['x-encrypted'] === 'true' && response.data) {
    try {
      const { encryptedData, signature, aesKey } = response.data
      if (encryptedData && signature && aesKey) {
        const decryptedData = encryptionUtils.decryptResponse(encryptedData, null, signature, aesKey)
        response.data = decryptedData
      }
    } catch (error) {
      console.error('解密响应数据失败:', error)
    }
  }
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    store.dispatch('logout')
    router.push('/login')
    return Promise.reject(error)
  }
  if (error.response && error.response.status === 403) {
    router.push('/403')
  }
  return Promise.reject(error)
})

// 动态加载路由
import { loadDynamicRoutes } from './router'

// 将axios挂载到Vue原型
Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.use(permissionDirective)
Vue.config.productionTip = false

window.addEventListener('error', function(event) {
  if (event.message === 'Script error.') {
    event.preventDefault()
  }
})

// 加载动态路由
loadDynamicRoutes()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')